import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPartiesMain } from './modules/ui/Main';

const PartiesPage = (
  <SuspensePage>
    <PagesPartiesMain />
  </SuspensePage>
);

export default PartiesPage;
